<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolDocumentManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Student Documents",
                description: "Store and review documents associated with student records.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Staff Documents",
                description: "Store and review documents associated with staff records.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
